<template>
  <div>
    <form @submit.prevent="submitForm" id="create_material_category_form">
      <div class="row g-3">

        <div class="col-12 mb-4">
          <label class="form-label form-label-thin">Name <span class="text-danger">*</span></label>
          <input
            v-model="form.name"
            type="text" name="name" id="name" ref="name"
            class="form-control fs-12"
            :class="{ 'is-invalid': errors.name }"
            placeholder="Enter category name"
            maxlength="120"
          />
          <div v-if="errors.name" class="invalid-feedback">{{ errors.name[0] }}</div>
        </div>

        <div class="col-12 mb-4">
          <label class="form-label form-label-thin">Description</label>
          <textarea
            v-model="form.description" name="description" id="description" ref="description"
            class="form-control fs-12"
            :class="{ 'is-invalid': errors.description }"
            placeholder="Enter description (optional)"
            rows="4"
            maxlength="5000"
          ></textarea>
          <div v-if="errors.description" class="invalid-feedback">{{ errors.description[0] }}</div>
        </div>

      </div>

      <div class="d-flex justify-content-end gap-2 mt-4">
        <button type="button" class="btn btn-sm btn-outline-secondary fs-12" @click="$emit('close')">
          Cancel
        </button>
       <button type="submit" class="btn btn-primary py-1 px-2 text-light hover-white btn-sm form-submit-btn">
        <i class="fa-solid fa-plus fs-12"></i> Create
      </button>
      </div>
    </form>
  </div>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'

export default {
  name: 'CreateCategory',
  emits: ['created', 'close'],
 

  data() {
    return {
      submitting: false,
      form: {
        name: '',
        description: '',
      },
      errors: {}
    }
  },
  methods: {
  async submitForm() {
    this.submitting = true
    this.errors = {}

    const result = await form_api_submit({
        url: 'material-categories/create',
        method: 'POST',
        data: this.form,
        curr_form_id: '#create_material_category_form',  // Add this - match your form's ID
        show_success_toast: true,
        show_error_toast: true,
        remove_pre_toasts: true
    })

    if (result.success) {
        this.resetForm()
        this.$emit('created')
    } else if (result?.data?.error_type === 'validation') {
        this.errors = result.data.errors
    }

    this.submitting = false
},

    resetForm() {
      this.form = { name: '', description: '' }
      this.errors = {}
    }
  }
}
</script>